import {
  Button,
  DrawerOverlay,
  HexIcon,
  Icons,
  Placeholder as StatusMessage,
  Stack,
} from '@cast/design-system';

type Props = {
  onClose: () => void;
  onContinue: () => void;
};

export const CloseGuardOverlay = ({ onContinue, onClose }: Props) => {
  return (
    <DrawerOverlay>
      <StatusMessage
        icon={
          <HexIcon
            variant="check"
            icon={<Icons.Question weight="fill" />}
            size={64}
            iconColor="blue.500"
          />
        }
        title={
          <>
            Are you sure you want to <br />
            leave without saving?
          </>
        }
        body="Any unsaved changes will be lost."
        actions={
          <Stack direction="row" gap={16}>
            <Button variant="secondary" onClick={onClose}>
              Leave
            </Button>
            <Button type="submit" onClick={onContinue}>
              Continue editing
            </Button>
          </Stack>
        }
      />
    </DrawerOverlay>
  );
};
